import { Card, theme} from "antd";
import {useTranslation} from "react-i18next";
import {useState} from "react";


const ThemesCard = ({item, editHandle , }) => {
    const { token } = theme.useToken();
    const [hover, setHover] = useState(false);
    const { t } = useTranslation();
    const Edit = (id) => {
        editHandle(id)
    };
    return (
        <Card
            onClick={() => Edit(item.id)}
            size="small"
            title={<h3 style={{margin: 0,
                fontSize: "clamp(16px, 2vw, 18px)",
                fontWeight: 600,
                whiteSpace: "normal",
                wordBreak: "break-word"  }}>{item?.name}</h3>}
            style={{
                border: `1px solid ${hover ? token.colorPrimary : token.activeDay}`,
                transition: "all 0.3s ease",
                cursor: "pointer",
            }}
            hoverable
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {
                item?.questions_count &&
                <p style={{ margin: 0,
                    fontSize: "clamp(14px, 1.6vw, 17px)", }}>
                    { t("questionCount")} : <b>{item?.questions_count}</b>
                </p>
            }

        </Card>
    );
};

export default ThemesCard;
